<template>
  <div class="st-wrapper">
    <div class="filter">
      <sui-input placeholder="Filter IMEI ..." icon="search" @keyup="searchIMEIPressHandler" v-model="search" />&nbsp;
      <sui-input placeholder="Filter ICC ..." icon="search" @keyup="searchICCPressHandler" v-model="searchICC" />&nbsp;
      <sui-dropdown placeholder="Batch" selection :options="batchOptions" v-model="searchBatch" />&nbsp;
      <sui-dropdown :options="availableLabels" placeholder="Labels" selection v-model="searchLabel" />&nbsp;
      <sui-input placeholder="Filter Email ..." icon="search" @keyup="searchEmailPressHandler" v-model="searchEmail" />&nbsp;
      <sui-checkbox label="billable only" v-model="billableOnly"/>
      <sui-checkbox label="online only" v-model="onlineOnly"/>
      <sui-button @click="requestRefresh">Refresh</sui-button>
    </div>
    <!-- Desktop version -->
    <simple-table class="device-list" :data="filteredData"
                  :columns="stColumns"
                  :stretch="true"
                  @select="stSelectHandler"
                  :selectable="true"
                  :show-row-numbers="true"
                  :num-rows="999"
                  :st-api="stApi">
      <div>This is the slot</div>
    </simple-table>
  </div>
</template>

<script>
  import SimpleTable from "../simple-table/SimpleTable";
  import moment from 'moment'

    export default {
      name: "DeviceManagementList",
      components: {SimpleTable},
      props: ["data", "selectedId"],
      data: function() {
        return {
          stApi: {},
          stMobileColumns: [
            {header: "id", field: "ID"},
          ],
          stColumns: [
            {header: "id", field: "ID"},
            {header: "status", field: "NonBillable", format:"boolReverted", renderer: (rawValue, row) => {
              let disabled = "grey genderless icon large transparent visibility-hidden"
              let icons = []
                let inMinutes = moment.duration(moment().diff(row.LastLocationUpdate)).asMinutes()
                if (isNaN(inMinutes)) {
                  icons.push(disabled)
                } else if (inMinutes > 30) {
                  icons.push("red circular wifi icon")
                } else if (inMinutes > 10) {
                  icons.push("orange circular wifi icon")
                } else {
                  icons.push("green circular wifi icon")
                }
                if (row.NonBillable) {
                  icons.push(disabled)
                } else {
                  if (row.BillingStatus === "active") {
                    // Billing is set up
                    if (row.BillingCancelAtPeriodEnd) {
                      icons.push("green circular dollar sign icon")
                    } else {
                      icons.push("green circular inverted dollar sign icon")
                    }

                  } else if (!isNaN(inMinutes)) {
                    // Billing is not set up, but there are updates
                    icons.push("orange circular inverted dollar sign icon")
                  } else {
                    // No updates from the device
                    icons.push("grey circular dollar sign icon")
                  }
                }
                if (icons.length > 0) {
                 return `<span><i class="` + icons.join(`"></i></span><span><i class="`) + `"></i></span>`
                } else {
                  return "&nbsp;"
                }
              }
            },
            {header: "billing", field: "BillingStatus"},
            {header: "icc", field: "ICC"},
            {header: "device name", field: "Name"},
            {header: "owner email", field: "OwnerEmail", format: "ownerEmail"},
            // {header: "gsm (provider, mo/mt)", field:"DataUsage", format: "usage"},
            {header: "est. cost", field:"EstimatedCost", renderer: (rawValue) => {
              return "€ " + (rawValue || 0).toFixed(2);
            }},
            // {header: "labels", field: "Labels", format: "labels"},
          ],
          search: "",
          searchICC: "",
          searchBatch: "",
          batchOptions: [{key: "", value: "", text: "Any Batches"}],
          searchLabel: "",
          searchEmail: "",
          availableLabels: [{key: "", value: "", text: "Any Labels"}],
          billableOnly: false,
          onlineOnly: false,
        }
      },

      methods: {
        requestRefresh() {
          this.$emit('refresh')
        },
        stSelectHandler(item) {
          this.$emit("select", item)
        },
        searchIMEIPressHandler() {
          this.searchBatch = ""
          this.searchLabel = ""
          this.searchICC = ""
          this.searchEmail = ""
          this.stApi.filter(this.search, "ID")
          this.$emit('unselect')
          this.stApi.selectById(null)
        },
        searchICCPressHandler() {
          this.search = ""
          this.searchLabel = ""
          this.searchEmail = ""
          this.stApi.filter(this.searchICC, "ICC")
          this.$emit('unselect')
          this.stApi.selectById(null)
        },
        searchEmailPressHandler() {
          this.search = ""
          this.searchLabel = ""
          this.searchICC = ""
          this.searchBatch = ""
          this.stApi.filter(this.searchEmail, "OwnerEmail")
          this.$emit('unselect')
          this.stApi.selectById(null)
        }
      },
      computed: {
          filteredData() {
            let filtered = (this.data || []).concat()
            if (this.billableOnly) {
              let newFiltered = [];
              (filtered).forEach((item) => {
                 if (!item.NonBillable) {
                     newFiltered.push(item)
                 }
              });
              filtered = newFiltered
            }

            if (this.onlineOnly) {
              let newFiltered = []
              filtered.forEach((item) => {
                let inMinutes = moment.duration(moment().diff(item.LastLocationUpdate)).asMinutes()
                if (!isNaN(inMinutes)) {
                  newFiltered.push(item)
                }
              })
              filtered = newFiltered
            }
            return filtered
          }
      },
      watch: {
        data: function(newValue) {
          // create batch options
          let batchOptions = {}
          let labelOptions = {}
          for (let i = 0; i < (newValue || []).length; i++) {
            let item = (newValue || [])[i]
            batchOptions[item.Batch] = true;
            (item.Labels ||  []).forEach((label) => {
              labelOptions[label] = true
            })
          }
          let batchOptionsResults = [{key: "", value: "", text: "Any Batches"}]
          Object.keys(batchOptions).forEach((key) => {
            batchOptionsResults.push({
              key: key,
              text: key,
              value: key,
            })
          })
          this.batchOptions = batchOptionsResults
          let labelOptionsResults =  [{key: "", value: "", text: "Any Labels"}]
          Object.keys(labelOptions).forEach((label) => {
            labelOptionsResults.push({
              key: label,
              text: label,
              value: label,
            })
          })
          this.availableLabels = labelOptionsResults
          if (this.searchBatch) {
            this.$nextTick(() => {
              this.stApi.filter(this.searchBatch, "Batch")
            })
          }
          if (this.searchLabel) {
            this.$nextTick(() => {
              this.stApi.filter(this.searchLabel, "Labels")
            })
          }

        },
        searchBatch(newValue) {
          this.$emit('unselect')
          this.stApi.selectById(null)
          if (newValue) {
            this.search = ""
            this.searchICC = ""
            this.searchLabel = ""
            this.searchEmail = ""
            this.$nextTick(() => {
              this.stApi.filter(newValue, "Batch")
            })
            return
          }
          this.stApi.filter(newValue, "Batch")
        },
        searchLabel(newValue) {
          this.$emit('unselect')
          this.stApi.selectById(null)
          if (newValue) {
            this.search = ""
            this.searchICC = ""
            this.searchBatch = ""
            this.searchEmail = ""
            this.$nextTick(() => {
              this.stApi.filter(newValue, "Labels")
            })
            return
          }
          this.stApi.filter(newValue, "Labels")
        },
      }
    }
</script>

<style scoped lang="less">
 .filter {
   background: #F0F0F0;
   > * {
     margin: 3pt 2pt;
   }
 }
 .device-list {
   box-sizing: border-box;
   overflow-x: auto;
   width: 100%;
 }
</style>
